export class Cns {
  static isValid(cnsInput: string | null | undefined): boolean {
    if (!cnsInput) {
      return false;
    }

    const cns = cnsInput.replace(/\D/g, '');
    if (cns.length !== 15) {
      return false;
    }

    const firstDigit = cns[0];

    if (['7', '8', '9'].includes(firstDigit)) {
      return this.validateCnsStartingWith789(cns);
    }

    if (['1', '2'].includes(firstDigit)) {
      return this.validateCnsStartingWith12(cns);
    }

    return false;
  }

  private static validateCnsStartingWith789(cns: string): boolean {
    let sum = 0;
    for (let i = 0; i < 15; i++) {
      sum += parseInt(cns[i], 10) * (15 - i);
    }
    return sum % 11 === 0;
  }

  private static validateCnsStartingWith12(cns: string): boolean {
    const pisNumber = cns.substring(0, 11);

    const calculateWeightedSum = (input: string, extra = 0) =>
      input.split('').reduce((acc, digit, idx) => acc + parseInt(digit, 10) * (15 - idx), extra);

    let sum = calculateWeightedSum(pisNumber);
    let remainder = sum % 11;
    let checkDigit = 11 - remainder;

    if (checkDigit === 11) {
      checkDigit = 0;
    }

    if (checkDigit === 10) {
      sum = calculateWeightedSum(pisNumber, 2);
      remainder = sum % 11;
      checkDigit = 11 - remainder;
      return cns === `${pisNumber}001${checkDigit}`;
    }

    return cns === `${pisNumber}000${checkDigit}`;
  }
}
